import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Day from './Day'
import { parseMonth, yearMonthDay } from 'redux/reducers/calendar/utls.js'

const Days = ({ week }) => {
  const { date } = useSelector((state) => state.calendar)
  const month = parseMonth(date)
  return week.map((day) => {
    if (Number(day.$M) + 1 !== Number(month)) {
      return <span key={yearMonthDay(day)} className="Calendar-item Calendar-item--empty"></span>
    }

    return <Day key={yearMonthDay(day)} day={day} />
  })
}

export default withTranslation('common')(Days)
